/**
 * gets a random ID
 */
export function getRandomId(): string {
	const charsLower = 'abcdefghijklmnopqrstuvwxyz';
	const seed = charsLower + charsLower.toUpperCase() + '0123456789';
	const randomChar = (seedString = seed) => seedString[Math.floor(Math.random() * seedString.length)];
	const randomString = length => Array.from({ length }, randomChar).join('');
	return `${new Date().getTime().toString(36)}-${randomString(3)}`;
}
